<template>
  <VMenu
    v-model="datePicker"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
  >
    <template #activator="{ on }">
      <slot name="activator" :on="{ click: showDatePicker }" />
    </template>
    <VDatePicker
      v-model="selectedDate"
      first-day-of-week="1"
      :locale="$i18n.locale"
      v-bind="$attrs"
      @input="change"
    >
      <VSpacer />
    </VDatePicker>
  </VMenu>
</template>

<script>
export default {
  name: 'DatePicker',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedDate: this.date,
    };
  },
  computed: {
    datePicker: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    change() {
      this.update();
      this.datePicker = false;
    },
    showDatePicker() {
      this.datePicker = true;
    },
    hideDatePicker() {
      this.datePicker = false;
    },
    update() {
      this.$emit('change', this.selectedDate);
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  cancel: Cancel
  update: Update
</i18n>

<i18n locale="ru" lang="yaml">
  cancel: Отмена
  update: Обновить
</i18n>
